import React from 'react';
import { motion } from 'framer-motion';
import { TrophyIcon, PackageIcon, RocketIcon } from 'lucide-react';
const credentials = [{
  icon: TrophyIcon,
  text: '+700 alumnos ayudados'
}, {
  icon: PackageIcon,
  text: 'Cientos de productos digitales creados'
}, {
  icon: RocketIcon,
  text: 'Experto en IA aplicada a negocios digitales'
}];
export function Instructor() {
  return <section className="w-full bg-navy-card px-4 py-16 md:py-24" data-id="element-48">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7
    }} className="max-w-3xl mx-auto text-center" data-id="element-49">
        <p className="font-oswald text-sm tracking-widest text-red uppercase mb-2" data-id="element-50">
          Tu instructor
        </p>
        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase mb-6" data-id="element-51">
          Francisco
        </h2>
        <p className="text-gray font-inter text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-10" data-id="element-52">
          Creador de Start Launching Creatives. Ha ayudado a más de 700 personas
          a crear y lanzar sus productos digitales sin aparecer en cámara y sin
          complicaciones.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10" data-id="element-53">
          {credentials.map(cred => <motion.div key={cred.text} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex items-center gap-3" data-id="element-54">
              <cred.icon className="w-6 h-6 text-red flex-shrink-0" data-id="element-55" />
              <span className="text-white font-inter text-sm md:text-base" data-id="element-56">
                {cred.text}
              </span>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}